<template>
  <svg
    v-if="iconName === 'BankCard'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M24 7.64062V6.375C24 4.92525 22.8248 3.75 21.375 3.75H2.625C1.17525 3.75 0 4.92525 0 6.375V7.64062C0 7.77005 0.104953 7.875 0.234375 7.875H23.7656C23.895 7.875 24 7.77005 24 7.64062Z"
      fill="#B0B7C3"
    />
    <path
      d="M0 9.60938V17.625C0 19.0747 1.17525 20.25 2.625 20.25H21.375C22.8248 20.25 24 19.0747 24 17.625V9.60938C24 9.47995 23.895 9.375 23.7656 9.375H0.234375C0.104953 9.375 0 9.47995 0 9.60938ZM6 15.75C6 16.1642 5.66419 16.5 5.25 16.5H4.5C4.08581 16.5 3.75 16.1642 3.75 15.75V15C3.75 14.5858 4.08581 14.25 4.5 14.25H5.25C5.66419 14.25 6 14.5858 6 15V15.75Z"
      fill="#0E243A"
    />
  </svg>
  <svg
    v-else-if="iconName === 'Sim'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_1516_18866)">
      <path
        d="M22.2455 5.81085L16.8522 0.641616C16.7568 0.550982 16.6276 0.5 16.4924 0.5H7.84398C7.09383 0.5 6.5 1.00003 6.05542 2.07518H14.4207C14.8282 2.07518 15.2118 2.22622 15.5 2.50003L20.5528 7.22548C20.841 7.49929 21 7.86369 21 8.25079V22C22 21.5 22.3946 20.8834 22.3946 20.1707V6.15259C22.3946 6.0242 22.3409 5.90148 22.2455 5.81085Z"
        fill="#0E243A"
        fill-opacity="0.6"
      />
      <path
        d="M15.4659 2.53655L20.5184 7.26173C20.5184 7.26178 20.5185 7.26183 20.5185 7.26187C20.797 7.52652 20.95 7.87788 20.95 8.25079V22V22.0809L21.0224 22.0448C21.5271 21.7924 21.8829 21.5087 22.1127 21.1946C22.3429 20.8798 22.4446 20.5371 22.4446 20.1707V6.15259C22.4446 6.01006 22.385 5.87437 22.2799 5.7746L16.8868 0.605519L16.8866 0.605366C16.7817 0.505675 16.6401 0.45 16.4924 0.45H7.84398C7.06439 0.45 6.45727 0.972526 6.00921 2.05607L5.98064 2.12518H6.05542H14.4207C14.8158 2.12518 15.1869 2.27154 15.4656 2.53628L15.4659 2.53655Z"
        stroke="#0E243A"
        stroke-opacity="0.6"
        stroke-width="0.1"
      />
      <path
        d="M14.1733 4.13317C14.0854 4.04794 13.9664 4 13.8419 4H5.87501C4.84089 4 4 4.81541 4 5.81815V22.1818C4 23.1846 4.84089 24 5.87501 24H17.125C18.1591 24 19 23.1846 19 22.1818V8.99999C19 8.87926 18.9506 8.76382 18.8627 8.6786L14.1733 4.13317ZM10.5625 11.7273C10.5625 11.476 10.7721 11.2727 11.0312 11.2727H12.4375C12.6966 11.2727 12.9062 11.476 12.9062 11.7273V13.5455C12.9062 13.7967 12.6966 14 12.4375 14H11.0312C10.7721 14 10.5625 13.7967 10.5625 13.5455V11.7273ZM6.81249 12.6363C6.81249 11.8844 7.44328 11.2727 8.21874 11.2727H9.15622C9.41533 11.2727 9.62499 11.476 9.62499 11.7273V13.5455C9.62499 13.7967 9.41533 14 9.15622 14H7.28121C7.02211 14 6.81245 13.7967 6.81245 13.5455V12.6363H6.81249ZM9.62499 20.8182C9.62499 21.0694 9.41533 21.2727 9.15622 21.2727H8.21874C7.44328 21.2727 6.81249 20.661 6.81249 19.9091V19C6.81249 18.7488 7.02216 18.5455 7.28126 18.5455H9.15627C9.41537 18.5455 9.62503 18.7488 9.62503 19V20.8182H9.62499ZM13.375 20.8182C13.375 21.0694 13.1653 21.2727 12.9062 21.2727H11.0312C10.7721 21.2727 10.5625 21.0694 10.5625 20.8182V19C10.5625 18.7487 10.7721 18.5454 11.0312 18.5454H12.9062C13.1653 18.5454 13.375 18.7487 13.375 19V20.8182H13.375ZM16.1875 19.9091C16.1875 20.661 15.5567 21.2727 14.7812 21.2727C14.5221 21.2727 14.3124 21.0694 14.3124 20.8182V18.0909C14.3124 17.8401 14.1023 17.6363 13.8437 17.6363H7.28126C7.02216 17.6363 6.81249 17.433 6.81249 17.1818V15.3636C6.81249 15.1123 7.02216 14.909 7.28126 14.909H15.7187C15.9778 14.909 16.1875 15.1123 16.1875 15.3636V19.9091H16.1875ZM16.1875 13.5455C16.1875 13.7967 15.9778 14 15.7187 14H14.3124C14.0533 14 13.8437 13.7967 13.8437 13.5455V11.7273C13.8437 11.476 14.0533 11.2727 14.3124 11.2727H14.7812C15.5567 11.2727 16.1875 11.8844 16.1875 12.6363V13.5455Z"
        fill="#0E243A"
      />
    </g>
    <defs>
      <clipPath id="clip0_1516_18866">
        <rect
          width="24"
          height="24"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
  <svg
    v-else-if="iconName === 'cvv'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M22.8363 17.9209H1.16372C0.715172 17.9209 0.351562 17.5573 0.351562 17.1087V3.14907C0.351562 2.70052 0.715172 2.33691 1.16372 2.33691H22.8363C23.2848 2.33691 23.6484 2.70052 23.6484 3.14907V17.1087C23.6484 17.5573 23.2848 17.9209 22.8363 17.9209Z"
      fill="#F4F6F9"
    />
    <path
      d="M0.351562 5.68213H23.6484V8.68213H0.351562V5.68213Z"
      fill="#B0B7C3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.206 19.4124C22.0279 18.3863 22.5197 17.0845 22.5197 15.6676C22.5197 12.3565 19.8356 9.67236 16.5245 9.67236C13.2135 9.67236 10.5293 12.3565 10.5293 15.6676C10.5293 17.0845 11.0211 18.3863 11.843 19.4124H11.8429C12.9416 20.7841 14.6303 21.6628 16.5245 21.6628C18.4186 21.6628 20.1074 20.7841 21.2061 19.4124H21.206Z"
      fill="#B0B7C3"
    />
    <path
      d="M14.7349 16.204V15.3784C14.7349 14.6008 14.2117 14.0344 13.4677 14.0344C12.7189 14.0344 12.1957 14.6008 12.1957 15.3784V16.204C12.1957 16.9864 12.7189 17.5528 13.4677 17.5528C14.2117 17.5528 14.7349 16.9864 14.7349 16.204ZM12.8533 16.204V15.3784C12.8533 14.9416 13.1029 14.6824 13.4677 14.6824C13.8277 14.6824 14.0773 14.9416 14.0773 15.3784V16.204C14.0773 16.6456 13.8277 16.9048 13.4677 16.9048C13.1029 16.9048 12.8533 16.6456 12.8533 16.204ZM17.691 16.5304C17.691 16.1464 17.4702 15.8776 17.2158 15.7576C17.4126 15.6232 17.595 15.3544 17.595 15.0232C17.595 14.4808 17.1918 14.0344 16.491 14.0344C15.891 14.0344 15.3054 14.452 15.3054 15.1624H15.9678C15.963 14.884 16.1838 14.6824 16.491 14.6824C16.7406 14.6824 16.9374 14.8408 16.9326 15.076C16.9278 15.316 16.7598 15.484 16.443 15.484H16.1838V16.0216H16.4718C16.8078 16.0216 17.0286 16.1944 17.0286 16.4776C17.0238 16.7368 16.8078 16.9048 16.5102 16.9048C16.1742 16.9048 15.9294 16.7272 15.8958 16.396H15.243C15.267 17.1448 15.8622 17.5528 16.5102 17.5528C17.2158 17.5528 17.691 17.1304 17.691 16.5304ZM19.7737 17.5H20.4313V16.7224H20.8777V16.1176H20.4313V14.092H19.8457L18.0793 16.1896V16.7224H19.7737V17.5ZM19.7737 16.1176H18.8905L19.7737 15.0664V16.1176Z"
      fill="white"
    />
  </svg>
  <svg
    v-else-if="iconName === 'visa'"
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="16"
    viewBox="0 0 40 24"
    fill="none"
  >
    <path
      d="M14.9683 6.2063L9.80238 17.8109H6.44365L3.90635 8.5616C3.76032 7.99427 3.61429 7.78797 3.13968 7.54728C2.37302 7.15186 1.11349 6.77364 0 6.55014L0.0730159 6.2063H5.49444C6.1881 6.2063 6.80873 6.6361 6.95476 7.39255L8.30556 14.0974L11.6278 6.2063H14.9683ZM28.1659 14.0287C28.1841 10.9685 23.6754 10.7966 23.6936 9.4384C23.7119 9.02579 24.1317 8.5788 25.0444 8.45845C25.5008 8.40688 26.7603 8.3553 28.1841 8.97421L28.75 6.51576C27.9833 6.25788 26.9976 6 25.7746 6C22.6167 6 20.4079 7.58166 20.3897 9.83381C20.3714 11.5014 21.9778 12.4298 23.1825 12.9971C24.4238 13.5645 24.8437 13.9255 24.8437 14.4413C24.8437 15.2149 23.8579 15.5587 22.9452 15.5759C21.3389 15.5931 20.4079 15.1633 19.6778 14.8367L19.0936 17.3811C19.8421 17.7077 21.2111 17.9828 22.6349 18C25.9571 18 28.1476 16.4355 28.1659 14.0287ZM36.4897 17.8109H39.4286L36.8548 6.2063H34.1349C33.5325 6.2063 33.0032 6.53295 32.7841 7.0659L28.0016 17.8109H31.3421L31.9992 16.0745H36.0881L36.4897 17.8109ZM32.9302 13.702L34.6095 9.35244L35.577 13.702H32.9302ZM19.5317 6.2063L16.8849 17.8109H13.7087L16.3373 6.2063H19.5317Z"
      fill="#1434CB"
    />
  </svg>

  <svg
    v-else-if="iconName === 'mastercard'"
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="16"
    viewBox="0 0 28 24"
    fill="none"
  >
    <path
      d="M17.5742 5.73193H10.5063V18.2869H17.5742V5.73193Z"
      fill="#FF5F00"
    />
    <path
      d="M10.9547 12.0088C10.9547 9.56879 12.099 7.2397 14.0511 5.73133C10.5508 3.00297 5.45748 3.60188 2.72008 7.08443C-0.0173181 10.567 0.566063 15.5801 4.08878 18.2863C7.02812 20.571 11.1342 20.571 14.0736 18.2863C12.0766 16.7557 10.9323 14.4488 10.9547 12.0088Z"
      fill="#EB001B"
    />
    <path
      d="M27.0875 12.0095C27.0875 16.4237 23.4751 19.995 19.01 19.995C17.1925 19.995 15.4424 19.396 14.0288 18.287C17.5291 15.5586 18.1349 10.5233 15.3975 7.06294C14.9936 6.55276 14.5449 6.10912 14.0288 5.70985C17.5291 2.98148 22.6224 3.58039 25.3823 7.06294C26.4817 8.4604 27.0875 10.2128 27.0875 12.0095Z"
      fill="#F79E1B"
    />
  </svg>
  <svg
    v-else-if="iconName === 'mir'"
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="16"
    viewBox="0 0 202 93"
    fill="none"
  >
    <path
      d="M140.806 45.0574V73.3501H158.112V57.4183H175.417C184.481 57.4183 192.173 52.3366 195.194 45.0574H140.806Z"
      fill="#006848"
    />
    <path
      d="M189.975 24.4566C186.542 21.2977 182.147 19.5122 177.202 19.5122H140.12C140.257 21.023 140.394 22.3964 140.669 23.7698C140.806 24.0445 140.806 24.3192 140.944 24.7313C140.944 24.8686 140.944 25.0059 141.081 25.1433C144.102 34.8947 153.304 42.0365 164.017 42.0365H195.881C196.018 40.9378 196.156 39.839 196.156 38.7403C196.156 32.9719 193.821 27.8901 189.975 24.4566Z"
      fill="url(#paint0_linear_505_470)"
    />
    <path
      d="M110.316 25.1433L98.2299 51.2385H96.9938V19.5122H79.8259V73.4881H94.3843C98.2299 73.4881 101.663 71.2906 103.312 67.857L115.398 41.7618H116.634V73.6255H133.802V19.5122H119.243C115.398 19.5122 111.827 21.7097 110.316 25.1433Z"
      fill="#006848"
    />
    <path
      d="M30.3823 26.5169L37.5241 51.2387H38.7602L45.902 26.5169C47.1381 22.2592 50.9837 19.375 55.3787 19.375H72.5466V73.3509H55.3787V41.4873H54.1426L44.3913 73.3509H32.1677L22.4163 41.4873H21.1803V73.3509H3.875V19.5123H21.0429C25.4379 19.5123 29.1462 22.3966 30.3823 26.5169Z"
      fill="#006848"
    />
    <defs>
      <linearGradient
        id="paint0_linear_505_470"
        x1="140.061"
        y1="30.6486"
        x2="196.156"
        y2="30.6486"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.0107527"
          stop-color="#00AFFF"
        />
        <stop
          offset="1"
          stop-color="#1F5BD7"
        />
      </linearGradient>
    </defs>
  </svg>
  <svg
    v-else-if="iconName === 'humo'"
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="20"
    viewBox="0 0 27 16"
    fill="none"
  >
    <path
      d="M25.3458 16H0.9875C0.441083 16 0 15.5608 0 15.0168V0.983204C0 0.439164 0.441083 0 0.9875 0H25.3458C25.8922 0 26.3333 0.439164 26.3333 0.983204V15.0168C26.3333 15.5608 25.8922 16 25.3458 16Z"
      fill="white"
    />
    <path
      d="M9.73048 0.51157C12.5416 0.51157 15.3494 0.521402 18.1604 0.505016C18.9307 0.501738 19.7042 0.495184 20.4745 0.485352C20.5403 0.485352 20.6061 0.495184 20.672 0.498461C20.9847 0.52468 21.067 0.777035 21.1295 1.03922C21.7944 3.8053 21.5838 6.75164 20.4021 9.35712C20.0894 10.0519 19.7042 10.7041 19.2796 11.3334C18.9472 11.8282 18.5818 12.3002 18.1868 12.7492C17.8905 13.0835 17.5778 13.4014 17.2486 13.6996C16.6265 14.26 15.9649 14.7713 15.1946 15.122C14.7865 15.3088 14.3586 15.4268 13.9109 15.489C13.4665 15.5513 13.0189 15.5513 12.5745 15.5415C10.1123 15.489 7.64686 15.5284 5.18469 15.5185C3.91082 15.512 2.63365 15.5185 1.35977 15.5185C1.22811 15.5185 1.09644 15.5087 0.968065 15.4661C0.708023 15.3809 0.546732 15.1547 0.533565 14.85C0.530273 14.7647 0.530273 14.6795 0.530273 14.591C0.530273 10.1896 0.530273 5.7881 0.530273 1.38662C0.530273 1.26208 0.533565 1.13427 0.556607 1.00973C0.615857 0.708211 0.856148 0.527957 1.16227 0.508293C1.26761 0.501738 1.37623 0.505016 1.48157 0.505016C4.2334 0.51157 6.98194 0.51157 9.73048 0.51157Z"
      fill="#2F4653"
    />
    <path
      d="M21.0447 12.4508C21.1961 12.4082 21.3212 12.323 21.4397 12.228C21.9367 11.8314 22.3087 11.33 22.6247 10.7827C23.7636 8.8097 24.4351 6.59749 24.5667 4.31646C24.5799 4.08376 24.5832 3.85107 24.5898 3.62166C24.5898 3.58561 24.5832 3.54956 24.6128 3.51351C24.705 3.53972 24.784 3.58561 24.8597 3.64788C25.7419 4.42789 25.8933 5.90597 25.7945 6.99732C25.5674 9.58315 24.1322 12.346 21.8281 13.6831C21.7754 13.7126 21.7227 13.7454 21.6668 13.7716C21.3113 13.9617 20.9426 14.1092 20.5608 14.237C20.4884 14.2599 20.416 14.2861 20.3468 14.3091C20.6595 14.2927 21.094 14.237 21.5845 14.0764C22.8979 13.6471 23.9446 12.677 24.6721 11.5266C24.8498 11.2448 25.0111 10.9531 25.1691 10.6581C25.179 10.6417 25.1889 10.6221 25.2119 10.6155C25.2415 10.6155 25.2514 10.6385 25.2613 10.6614C25.6267 11.5004 25.5312 12.3623 25.0177 13.1194C24.0039 14.6139 21.8643 15.502 20.0934 15.5119C18.4607 15.5184 16.8313 15.5151 15.1987 15.5151C15.146 15.5151 15.0703 15.5414 15.0538 15.4693C15.0374 15.3939 15.123 15.4004 15.169 15.3808C17.6444 14.2468 19.5173 12.2706 20.7385 9.85845C21.7985 7.76094 22.3317 5.38815 22.1243 3.03829C22.0585 2.2845 21.917 1.54054 21.703 0.81625C21.6898 0.773645 21.6734 0.731039 21.6635 0.685157C21.6339 0.527844 21.68 0.488516 21.8412 0.504903C22.2428 0.544231 22.595 0.691711 22.911 0.937512C23.5068 1.40617 23.7372 2.25173 23.8722 2.96291C24.129 4.29679 23.8656 5.7716 23.5529 7.07598C23.1447 8.77365 22.4568 10.432 21.466 11.8773C21.3607 12.0313 21.2389 12.1723 21.1237 12.323C21.1006 12.3656 21.0743 12.4082 21.0447 12.4508Z"
      fill="url(#paint0_linear_1516_19252)"
    />
    <path
      d="M6.93816 6.8498C6.93487 6.64005 6.86904 6.4303 6.68471 6.31231C6.50366 6.1976 6.26337 6.20088 6.12183 6.37458C6.11195 6.38769 6.08562 6.41391 6.0922 6.43357C6.09879 6.45324 6.14487 6.44996 6.16133 6.45979C6.19425 6.47618 6.20741 6.50895 6.20412 6.54173C6.20412 6.58105 6.20412 6.9645 6.20083 7.48888C5.7367 7.4856 5.26929 7.48232 4.80516 7.47905C4.79528 7.36434 4.79199 7.23652 4.80187 7.0956C4.80845 6.96778 4.82491 6.83669 4.85124 6.70887C4.86112 6.65315 4.87429 6.59744 4.89074 6.54173C4.9072 6.48273 4.94999 6.40735 4.9467 6.34508C4.9467 6.33525 4.94341 6.3287 4.94012 6.32214C4.92695 6.30576 4.90391 6.30903 4.88416 6.31559C4.76566 6.34508 4.65045 6.40735 4.55828 6.48929C4.53195 6.51551 4.45624 6.58433 4.38712 6.70559C4.20937 7.02349 4.19291 7.47577 4.19291 7.47577C4.18303 7.76745 4.17316 8.36065 4.48587 8.97679C4.48587 8.97679 4.70641 9.4094 5.01912 9.51428C5.08166 9.53394 5.09812 9.52083 5.1047 9.51428C5.12774 9.4815 5.07508 9.42907 5.06191 9.40613C5.03229 9.36352 5.00924 9.31436 4.98949 9.26848C4.9467 9.17016 4.91708 9.06528 4.89733 8.95713C4.83149 8.63595 4.7887 8.30821 4.79858 7.98048H6.20741C6.20741 8.39343 6.20741 8.80637 6.20741 9.21932C6.20741 9.30125 6.24033 9.37991 6.31604 9.41923C6.36212 9.44218 6.41479 9.45201 6.46416 9.45856C6.55304 9.46839 6.64521 9.47495 6.73408 9.45856C6.78675 9.44873 6.83612 9.42907 6.87562 9.39302C6.93816 9.33402 6.93816 9.25864 6.93816 9.17999C6.93816 8.55729 6.94475 7.93787 6.94475 7.31518C6.94146 7.15787 6.94146 7.00383 6.93816 6.8498Z"
      fill="url(#paint1_linear_1516_19252)"
    />
    <path
      d="M5.01028 9.67139C4.44083 9.50424 4.22029 8.90776 4.09849 8.38666C4.07216 8.27195 4.04583 8.16052 4.03266 8.04582C3.98658 7.69514 3.98987 7.31169 4.10179 6.97412C4.0162 6.99379 3.9767 7.06916 3.92404 7.12816C3.7397 7.34774 3.72324 7.60665 3.71666 7.86228C3.69691 8.46204 3.91416 8.8881 3.96354 8.97986C4.07545 9.18634 4.19395 9.32071 4.23016 9.36004C4.35524 9.50096 4.48362 9.59601 4.58237 9.66155C4.50666 9.64189 4.39474 9.60584 4.27954 9.53374C4.17091 9.46819 4.0952 9.39281 4.04254 9.3371C3.97012 9.24533 3.91745 9.16012 3.88454 9.1044C3.79566 8.94709 3.68045 8.75373 3.62449 8.49482C3.60804 8.42271 3.59816 8.34733 3.56854 8.34406C3.52574 8.34078 3.47966 8.48826 3.46979 8.52103C3.43687 8.62591 3.42699 8.72095 3.43029 8.77011C3.43358 8.96676 3.5817 9.35021 3.93391 9.60912C3.93391 9.60912 4.24333 9.83526 4.77328 9.85492C4.79633 9.85492 4.9247 9.85164 5.01687 9.78609C5.05966 9.74677 5.09258 9.69761 5.01028 9.67139Z"
      fill="url(#paint2_linear_1516_19252)"
    />
    <path
      d="M4.10156 6.97062V6.97376L4.1078 6.96436L4.10156 6.97062Z"
      fill="url(#paint3_linear_1516_19252)"
    />
    <path
      d="M14.2142 6.77723C14.2175 6.70513 14.2142 6.59698 14.1879 6.46916C14.1846 6.45605 14.1813 6.42328 14.1648 6.38395C14.155 6.36429 14.1319 6.30857 14.0727 6.27252C14.0398 6.25286 14.0068 6.23975 13.9706 6.23975C13.9443 6.23975 13.918 6.24302 13.8949 6.24302C13.8587 6.24302 13.8225 6.24302 13.7896 6.24302C13.7205 6.24302 13.6513 6.24302 13.5822 6.24302C13.5197 6.2463 13.4637 6.26597 13.4176 6.31185C13.365 6.36756 13.3222 6.44294 13.253 6.61337C13.2399 6.63958 13.2333 6.6658 13.2267 6.67891C13.2004 6.73463 12.8284 7.53758 12.6869 7.77027C12.677 7.78666 12.654 7.82599 12.6243 7.82271C12.5947 7.82271 12.5717 7.78666 12.5618 7.77027C12.4202 7.53758 12.0483 6.73463 12.0219 6.67891C12.0154 6.66253 12.0055 6.63958 11.9956 6.61337C11.9265 6.44622 11.8837 6.36756 11.831 6.31185C11.7882 6.26597 11.729 6.2463 11.6664 6.24302C11.5973 6.23975 11.5282 6.24302 11.4591 6.24302C11.4229 6.24302 11.3867 6.24302 11.3537 6.24302C11.3274 6.24302 11.3011 6.24302 11.278 6.23975C11.2418 6.23975 11.2056 6.25286 11.176 6.27252C11.1167 6.30857 11.0937 6.36429 11.0838 6.38395C11.0674 6.42328 11.0641 6.45605 11.0608 6.46916C11.0344 6.59698 11.0311 6.70513 11.0344 6.77723C11.0081 7.60313 10.9818 8.42902 10.9521 9.25164C10.9521 9.26475 10.9554 9.28441 10.962 9.30408C11.0048 9.42534 11.1595 9.48433 11.278 9.48433C11.3965 9.48433 11.5414 9.42862 11.5907 9.32046C11.5907 9.32046 11.6006 9.29752 11.6072 9.27458C11.6434 9.10744 11.6632 7.75389 11.6697 7.16396C11.9956 7.82599 12.2491 8.32087 12.3643 8.54045C12.3873 8.58634 12.44 8.67482 12.5322 8.7076C12.5585 8.71743 12.5881 8.72071 12.621 8.72071C12.6507 8.72071 12.6803 8.71415 12.7099 8.7076C12.8021 8.6781 12.8547 8.58634 12.8778 8.54045C12.9963 8.32087 13.2497 7.82599 13.5723 7.16396C13.5789 7.75389 13.5987 9.10744 13.6349 9.27458C13.6415 9.29752 13.648 9.32046 13.6513 9.32046C13.7007 9.42862 13.8455 9.48761 13.964 9.48433C14.0825 9.48433 14.2373 9.42206 14.28 9.30408C14.2866 9.28441 14.2899 9.26475 14.2899 9.25164C14.2702 8.42902 14.2405 7.60313 14.2142 6.77723Z"
      fill="url(#paint4_linear_1516_19252)"
    />
    <path
      d="M8.43207 8.73096C8.43865 8.73096 8.44523 8.73423 8.45181 8.73423C8.44523 8.74734 8.42878 8.74079 8.43207 8.73096Z"
      fill="white"
    />
    <path
      d="M10.3089 6.34152C10.2431 6.25631 10.1246 6.25303 10.0159 6.24975C9.91059 6.24647 9.77893 6.2432 9.69334 6.33496C9.64726 6.3874 9.63409 6.44639 9.6308 6.48244C9.62751 7.09203 9.62751 7.70162 9.62422 8.31121C9.62422 8.3702 9.62093 8.48163 9.55838 8.60617C9.49584 8.73727 9.40368 8.80937 9.38063 8.82903C9.38063 8.82903 9.22592 8.9503 9.02513 8.96668C9.00538 8.96668 8.98234 8.96996 8.98234 8.96996C8.97576 8.96996 8.97246 8.96996 8.96588 8.96996C8.9593 8.96996 8.95601 8.96996 8.94942 8.96996C8.94942 8.96996 8.92967 8.96996 8.90663 8.96668C8.70584 8.9503 8.55113 8.82903 8.55113 8.82903C8.52809 8.80937 8.43592 8.73727 8.37338 8.60617C8.31413 8.48163 8.30755 8.3702 8.30755 8.31121C8.30425 7.70162 8.30425 7.09203 8.30096 6.48244C8.29767 6.44639 8.2845 6.38412 8.23842 6.33496C8.15613 6.2432 8.02117 6.24647 7.91584 6.24975C7.80392 6.25303 7.68871 6.25631 7.62288 6.34152C7.57021 6.40707 7.5735 6.489 7.57679 6.52505C7.57679 7.16414 7.57679 7.79994 7.57679 8.43903C7.57679 8.616 7.62946 8.85197 7.80063 9.07811C7.99154 9.33047 8.26805 9.4419 8.35034 9.47139C8.5215 9.53366 8.68938 9.55333 8.74205 9.55661C8.83092 9.56644 8.90663 9.56644 8.96259 9.56316C9.01855 9.56644 9.09426 9.56316 9.18313 9.55661C9.2358 9.55005 9.40367 9.53366 9.57484 9.47139C9.66043 9.43862 9.93364 9.32719 10.1246 9.07811C10.2957 8.85525 10.3484 8.61928 10.3484 8.43903C10.3484 7.79994 10.3484 7.16414 10.3484 6.52505C10.3583 6.489 10.3616 6.40707 10.3089 6.34152Z"
      fill="url(#paint5_linear_1516_19252)"
    />
    <path
      d="M8.5918 9.52051C8.59838 9.52051 8.60167 9.52379 8.60825 9.52379L8.59838 9.53034L8.5918 9.52051Z"
      fill="white"
    />
    <path
      d="M17.9326 7.25897C17.8405 6.9509 17.6495 6.68216 17.3928 6.48879C17.0998 6.26921 16.7378 6.1545 16.3757 6.14795C16.0103 6.15778 15.6515 6.27249 15.3586 6.48879C15.1018 6.68216 14.9109 6.9509 14.8187 7.25897C14.5554 8.14057 14.9537 9.2647 15.905 9.51378C16.0597 9.5531 16.2177 9.56949 16.3757 9.56621C16.5337 9.56949 16.6917 9.5531 16.8464 9.51378C17.7977 9.26798 18.196 8.14057 17.9326 7.25897ZM17.2216 8.24545C17.1229 8.66167 16.8431 9.11066 16.3724 9.11722C15.9017 9.11394 15.6219 8.66495 15.5232 8.24545C15.4277 7.84233 15.4442 7.3704 15.6713 7.00989C15.8293 6.76081 16.0959 6.61333 16.3724 6.61333C16.6522 6.61661 16.9188 6.76409 17.0735 7.00989C17.3006 7.3704 17.3204 7.84233 17.2216 8.24545Z"
      fill="url(#paint6_linear_1516_19252)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1516_19252"
        x1="13.8658"
        y1="10.3014"
        x2="26.1088"
        y2="6.52657"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.329"
          stop-color="#9C8837"
        />
        <stop
          offset="0.5606"
          stop-color="#F7E59E"
        />
        <stop
          offset="0.6012"
          stop-color="#EFDD95"
        />
        <stop
          offset="0.6639"
          stop-color="#DDCA81"
        />
        <stop
          offset="0.7405"
          stop-color="#C4B062"
        />
        <stop
          offset="0.7875"
          stop-color="#B39F4D"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1516_19252"
        x1="6.26389"
        y1="8.24134"
        x2="4.01474"
        y2="6.53185"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.329"
          stop-color="#9C8837"
        />
        <stop
          offset="0.5606"
          stop-color="#F7E59E"
        />
        <stop
          offset="0.6012"
          stop-color="#EFDD95"
        />
        <stop
          offset="0.6639"
          stop-color="#DDCA81"
        />
        <stop
          offset="0.7405"
          stop-color="#C4B062"
        />
        <stop
          offset="0.7875"
          stop-color="#B39F4D"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1516_19252"
        x1="5.42211"
        y1="9.35002"
        x2="3.17296"
        y2="7.64053"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.329"
          stop-color="#9C8837"
        />
        <stop
          offset="0.5606"
          stop-color="#F7E59E"
        />
        <stop
          offset="0.6012"
          stop-color="#EFDD95"
        />
        <stop
          offset="0.6639"
          stop-color="#DDCA81"
        />
        <stop
          offset="0.7405"
          stop-color="#C4B062"
        />
        <stop
          offset="0.7875"
          stop-color="#B39F4D"
        />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1516_19252"
        x1="5.98949"
        y1="8.40067"
        x2="3.84411"
        y2="6.78419"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.329"
          stop-color="#9C8837"
        />
        <stop
          offset="0.5606"
          stop-color="#F7E59E"
        />
        <stop
          offset="0.6012"
          stop-color="#EFDD95"
        />
        <stop
          offset="0.6639"
          stop-color="#DDCA81"
        />
        <stop
          offset="0.7405"
          stop-color="#C4B062"
        />
        <stop
          offset="0.7875"
          stop-color="#B39F4D"
        />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1516_19252"
        x1="14.6242"
        y1="8.9344"
        x2="11.1245"
        y2="7.0699"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.329"
          stop-color="#9C8837"
        />
        <stop
          offset="0.5606"
          stop-color="#F7E59E"
        />
        <stop
          offset="0.6012"
          stop-color="#EFDD95"
        />
        <stop
          offset="0.6639"
          stop-color="#DDCA81"
        />
        <stop
          offset="0.7405"
          stop-color="#C4B062"
        />
        <stop
          offset="0.7875"
          stop-color="#B39F4D"
        />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1516_19252"
        x1="10.6942"
        y1="8.76303"
        x2="7.19638"
        y2="6.56351"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.329"
          stop-color="#9C8837"
        />
        <stop
          offset="0.5606"
          stop-color="#F7E59E"
        />
        <stop
          offset="0.6012"
          stop-color="#EFDD95"
        />
        <stop
          offset="0.6639"
          stop-color="#DDCA81"
        />
        <stop
          offset="0.7405"
          stop-color="#C4B062"
        />
        <stop
          offset="0.7875"
          stop-color="#B39F4D"
        />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1516_19252"
        x1="18.8467"
        y1="9.29719"
        x2="14.4961"
        y2="6.76103"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.329"
          stop-color="#9C8837"
        />
        <stop
          offset="0.5606"
          stop-color="#F7E59E"
        />
        <stop
          offset="0.6012"
          stop-color="#EFDD95"
        />
        <stop
          offset="0.6639"
          stop-color="#DDCA81"
        />
        <stop
          offset="0.7405"
          stop-color="#C4B062"
        />
        <stop
          offset="0.7875"
          stop-color="#B39F4D"
        />
      </linearGradient>
    </defs>
  </svg>
  <svg
    v-else-if="iconName === 'uzcard'"
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="20"
    viewBox="0 0 12 16"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.8804 6.6899C10.8804 8.66333 10.4294 10.1341 9.52789 11.0925C8.62616 12.0507 7.23311 12.5297 5.35509 12.5297C3.60035 12.5297 2.26917 12.0507 1.36155 11.0925C0.453472 10.1343 0 8.68916 0 6.7572V0.275346C0.000179512 0.202375 0.0292468 0.132444 0.0808454 0.0808454C0.132444 0.0292468 0.202375 0.000179512 0.275346 0L3.45713 0C3.53006 0.000298305 3.59992 0.0294037 3.6515 0.0809767C3.70307 0.13255 3.73217 0.202412 3.73247 0.275346V6.89884C3.73247 7.68772 3.87842 8.29484 4.17552 8.72316C4.39788 9.018 4.71497 9.22732 5.07348 9.31593C5.43199 9.40453 5.81007 9.36703 6.14419 9.20971C6.36568 9.10551 6.56047 8.95212 6.71369 8.76123C7.00422 8.35943 7.14881 7.76726 7.1479 6.98451V5.7442H10.8804V6.6899Z"
      fill="#273E76"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.5922 5.01969H7.14844V0.288491C7.14862 0.212033 7.17907 0.138759 7.23313 0.0846952C7.2872 0.0306316 7.36047 0.000179548 7.43693 0L7.95249 0C7.95309 0.775831 8.26179 1.51966 8.81071 2.06793C9.35973 2.61637 10.104 2.92448 10.88 2.92456H10.8809V5.01969H10.5922Z"
      fill="#273E76"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.68555 0H10.5921C10.6686 0.00023906 10.7418 0.0307103 10.7959 0.084761C10.8499 0.138812 10.8804 0.212052 10.8806 0.288491V2.19665C10.2986 2.19653 9.74045 1.96532 9.32884 1.55384C8.91723 1.14236 8.68585 0.584279 8.68555 0.00226623V0Z"
      fill="#F4821F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.625252 15.6776C1.04654 15.6776 1.24982 15.4433 1.24982 15.099V14.2694H0.948415V15.0906C0.948415 15.1768 0.914201 15.2594 0.853298 15.3203C0.792396 15.3812 0.709794 15.4154 0.623665 15.4154C0.537536 15.4154 0.454935 15.3812 0.394032 15.3203C0.33313 15.2594 0.298915 15.1768 0.298915 15.0906V14.2694H0V15.1015C0 15.4415 0.20328 15.678 0.624572 15.678L0.625252 15.6776ZM3.06915 15.6527V15.3936H2.40107L3.05487 14.5053V14.2687H2.01513V14.5279H2.66893L2.01513 15.4138V15.6518L3.06915 15.6527ZM4.47761 15.6776C4.59617 15.6803 4.71313 15.6499 4.81537 15.5898C4.91761 15.5297 5.00108 15.4423 5.0564 15.3374L4.80259 15.2151C4.77169 15.2751 4.72502 15.3255 4.6676 15.361C4.61018 15.3964 4.54418 15.4155 4.4767 15.4163C4.38977 15.4119 4.30592 15.3827 4.2351 15.3321C4.16427 15.2815 4.10945 15.2116 4.07712 15.1308C4.0448 15.05 4.03634 14.9616 4.05273 14.8761C4.06913 14.7906 4.1097 14.7116 4.16963 14.6485C4.25008 14.564 4.35999 14.5134 4.4767 14.5078C4.54406 14.5089 4.60987 14.5282 4.66721 14.5636C4.72455 14.599 4.77131 14.6491 4.80259 14.7088L5.0564 14.5841C5.00115 14.4794 4.91762 14.3922 4.81531 14.3325C4.713 14.2728 4.59601 14.243 4.47761 14.2465C4.35772 14.243 4.23888 14.2696 4.13198 14.324C4.02507 14.3784 3.93354 14.4588 3.86576 14.5577C3.79798 14.6567 3.75613 14.771 3.74405 14.8904C3.73197 15.0097 3.75004 15.1301 3.79661 15.2407C3.85279 15.3737 3.94789 15.4866 4.06944 15.5646C4.19098 15.6426 4.33327 15.682 4.47761 15.6776ZM7.05204 15.6527L6.5188 14.2694H6.1494L5.61389 15.6527H5.9502L6.03723 15.4183H6.63098L6.71596 15.6527H7.05204ZM6.54985 15.1591H6.11813L6.3341 14.5637L6.54985 15.1591ZM9.04133 15.9999L8.5337 15.1262C8.62441 15.1043 8.7045 15.0512 8.75988 14.9761C8.81526 14.9009 8.84238 14.8087 8.83647 14.7156C8.8388 14.6548 8.82823 14.5942 8.80546 14.5378C8.78268 14.4814 8.74821 14.4304 8.70432 14.3883C8.66043 14.3461 8.60812 14.3138 8.55082 14.2933C8.49352 14.2729 8.43254 14.2648 8.37189 14.2696H7.72375V15.6531H8.01836V15.1613H8.23433L8.70276 15.9996L9.04111 15.9999H9.04133ZM8.32815 14.9023H8.01904V14.5291H8.32725C8.35357 14.526 8.38023 14.5286 8.40549 14.5366C8.43075 14.5446 8.45404 14.5578 8.47382 14.5754C8.49361 14.593 8.50944 14.6147 8.52028 14.6388C8.53112 14.663 8.53672 14.6892 8.53672 14.7157C8.53672 14.7422 8.53112 14.7684 8.52028 14.7926C8.50944 14.8167 8.49361 14.8383 8.47382 14.856C8.45404 14.8736 8.43075 14.8868 8.40549 14.8948C8.38023 14.9028 8.35357 14.9054 8.32725 14.9023H8.32815ZM10.1473 15.6531C10.581 15.6531 10.882 15.3794 10.882 14.9624C10.882 14.5454 10.5803 14.2696 10.1473 14.2696H9.60155V15.6531H10.1473ZM10.1473 15.3939H9.89615V14.5291H10.1473C10.2053 14.5248 10.2635 14.5331 10.318 14.5534C10.3726 14.5736 10.4221 14.6054 10.4632 14.6465C10.5044 14.6876 10.5362 14.7371 10.5565 14.7916C10.5768 14.8461 10.5852 14.9044 10.581 14.9624C10.5835 15.02 10.574 15.0775 10.553 15.1312C10.532 15.1849 10.5001 15.2336 10.4591 15.2742C10.4182 15.3148 10.3692 15.3464 10.3154 15.367C10.2615 15.3876 10.2039 15.3966 10.1463 15.3936L10.1473 15.3939ZM11.2398 14.2431V14.2467C11.2398 14.2976 11.2247 14.3474 11.1964 14.3897C11.1681 14.432 11.128 14.465 11.0809 14.4845C11.0339 14.504 10.9821 14.5091 10.9322 14.4992C10.8823 14.4893 10.8364 14.4648 10.8004 14.4288C10.7644 14.3928 10.7398 14.347 10.7299 14.2971C10.7199 14.2471 10.725 14.1954 10.7444 14.1483C10.7639 14.1013 10.7969 14.0611 10.8392 14.0328C10.8815 14.0044 10.9312 13.9893 10.9821 13.9893H11.2396V14.2431H11.2398Z"
      fill="#273E76"
    />
  </svg>
  <svg
    v-else-if="iconName === 'elkard'"
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="20"
    viewBox="0 0 27 18"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.60542 10.8163C3.63253 11.0467 3.59187 10.9789 3.91717 10.9925L11.9142 10.9789C11.738 10.5994 11.1958 9.85392 10.9247 9.44729C10.5316 8.89157 10.247 8.44428 9.86747 7.90211L7.75301 4.81175C7.30572 5.4759 4.05271 10.5452 3.60542 10.8163ZM20.6837 10.9518L20.8328 11.2771L14.5572 11.2907C13.3916 11.2907 12.9578 11.4669 12.741 11.006L20.2093 10.9925L20.1687 10.8298C19.8298 10.2605 19.3554 9.62349 18.9759 9.06777C18.5693 8.45783 18.2033 7.90211 17.7696 7.27861L15.3434 3.63253L15.2078 3.60542H15.1807C14.0151 4.89307 12.7816 7.12952 11.7244 8.6747C11.6024 8.8509 11.5617 8.93223 11.4127 9.06777L9.52861 6.28916L11.5211 3.32078C11.8464 2.81928 12.1852 2.34488 12.497 1.85693C12.8087 1.38253 13.1611 0.881024 13.5 0.420181C13.7846 0.691265 14.1642 1.40964 14.4217 1.76205C15.6009 3.40211 16.8208 5.19127 17.9051 6.87199C18.759 8.2003 19.762 9.6506 20.6837 10.9518ZM19.247 4.20181L20.5482 2.35843C20.7651 2.73795 21.1175 3.25301 21.4157 3.65964C21.7274 4.10693 23.9774 7.37349 24.0452 7.61747C24.384 7.875 26.4036 11.0196 26.5392 11.25C25.6039 11.3313 23.3539 11.2636 22.1883 11.2636C21.1175 11.2636 21.1988 11.372 21.0361 10.9789L25.8343 10.884C25.7801 10.5994 24.0045 8.01054 23.7063 7.63102L21.7816 4.79819L19.3419 8.40361C19.1792 8.32229 19.3148 8.45783 19.1521 8.24096L18.5828 7.4006C18.3253 7.04819 18.0136 6.65512 17.8645 6.28916C18.0271 5.88253 18.881 4.77108 19.247 4.20181ZM0.284639 11.006C0.121988 11.2229 0.0271084 11.3042 0 11.5753H27C26.9729 11.2364 26.4849 10.6265 26.2545 10.2877L23.7877 6.68223C23.4895 6.24849 23.2861 5.88253 22.9744 5.4488C22.6898 5.05572 22.4729 4.71687 22.1747 4.28313C21.9172 3.91717 21.5919 3.45633 21.3479 3.06325C21.131 2.7244 20.7922 2.19578 20.5482 1.91114C20.2771 2.11446 18.1898 5.35392 17.756 5.9503L17.6476 6.07229C17.2274 5.28614 14.4352 1.40964 13.5542 0H13.4593L11.4262 3.00904C11.0738 3.53765 10.7756 4.01205 10.4096 4.51355C10.2199 4.78464 10.0708 5.01506 9.89458 5.25904C9.71837 5.50301 9.55572 5.78765 9.35241 6.01807C9.1762 5.86898 8.79669 5.27259 8.63404 5.04217C8.39006 4.67621 8.17319 4.3238 7.90211 3.95783C7.64458 3.59187 6.69578 2.08735 6.45181 1.89759C5.39458 3.45633 4.41867 4.86596 3.375 6.45181C3.11747 6.83133 2.87349 7.19729 2.61596 7.57681C2.34488 7.98343 2.12801 8.32229 1.85693 8.70181C1.3012 9.48795 0.826807 10.2877 0.284639 11.006ZM11.25 9.31175C11.5075 9.77259 12.3614 10.8434 12.5105 11.2907H1.03012C0.826807 11.2771 0.447289 11.3584 0.501506 11.1687C1.01657 10.4096 1.46386 9.75904 1.96536 9C2.14157 8.74247 6.26205 2.56175 6.51958 2.37199C7.33283 3.75452 8.62048 5.53012 9.56928 6.87199C9.85392 7.29217 10.1114 7.65813 10.4096 8.09187C10.6807 8.47139 10.9518 8.95934 11.25 9.31175Z"
      fill="#345A9B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.1747 17.6343C5.19127 17.6072 5.53012 17.3361 5.74699 16.4009C5.92319 15.6147 5.86898 14.6795 5.88253 13.8256L6.99398 13.812L7.03464 17.4988L8.24096 17.4852L8.22741 12.7819L4.70331 12.7684C4.63554 13.5003 4.67621 14.3 4.66265 15.0455C4.63554 16.3467 4.60843 16.3331 4.03916 16.6449L4.1747 17.6343ZM9.36596 17.5123H10.5587L10.613 15.5199C11.1822 16.0756 11.6566 16.9431 12.2123 17.5259L13.744 17.5123C13.4593 16.9702 12.2395 15.6825 11.7922 15.0455C12.0497 14.4762 13.378 13.2563 13.5678 12.7684L12.1039 12.7548C11.9006 13.0801 10.8705 14.3949 10.613 14.6524L10.5994 12.7548H9.40663L9.36596 17.5123ZM0.0135542 12.8632L0 14.3C0.338855 14.0696 0.555723 13.812 1.17922 13.8391C1.69428 13.8663 2.08735 14.1644 2.16867 14.5846L0.596386 14.5982L0.582831 15.5199L2.23645 15.5605C2.01958 16.4144 1.03012 16.7533 0.0135542 15.9672L0 17.3904C4.8253 18.9491 4.74398 11.3045 0.0135542 12.8632ZM16.0075 15.7232C16.1431 15.2217 16.3193 14.666 16.5361 14.2729L16.9834 15.7503L16.0075 15.7232ZM20.9142 15.9536C21.6596 15.9129 22.3374 15.9807 22.8117 15.5605C23.1913 15.2217 23.3946 14.4897 23.2184 13.812C22.8795 12.5108 21.0768 12.7277 19.6672 12.7684L19.7078 17.5123L20.887 17.4988L20.9142 15.9536ZM20.9142 13.7714C21.5377 13.7578 21.6461 13.7849 21.9714 14.0696C22.1069 14.1644 22.1069 14.544 21.9578 14.6524C21.6054 14.937 21.4157 14.9506 20.887 14.937L20.9142 13.7714ZM27 13.812V12.7548H23.8148L23.7877 13.7985H24.7907L24.8042 17.4852L26.0377 17.4988V13.8391L27 13.812ZM17.3087 16.6991L17.6883 17.5259L18.9352 17.4988C18.5151 16.1298 17.7289 14.0153 17.1596 12.7684L15.8178 12.7955L14.0422 17.5123H15.3027L15.6958 16.6991H17.3087Z"
      fill="#345A9B"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconWrapper',
  props: {
    iconName: {
      type: String,
      default: ''
    }
  }
};
</script>

<style>

</style>